<template>
  <page-500 v-if="$offline" :back="backFromOffline" :message="$t('shared.YouAreOffline')"/>
  <div v-else>
    <progress-bar></progress-bar>
    <notifications></notifications>
    <pub v-if="isPublic"></pub>
    <cp v-else></cp>
  </div>
</template>

<script>
import _ from 'lodash'
import * as types from '@/store/types'

import cp from './CP'
import pub from './Public'

import favicon from '@/../public/favicon'
import { ProgressBar, Notifications } from './core'
import { Page500 } from '@/components/shared'

import {mapState} from 'vuex'

export default {
  name: 'root',
  components: {
    cp,
    pub,
    ProgressBar,
    Notifications,
    Page500
  },
  metaInfo () {
    // favicon.metas.forEach(m => {
    //   if (m.content === 'APP_TITLE')
    //     m.content = this.$t('branding.AppName')
    // })

    // return {
    //   title: this.$t('branding.AppTagline'),
    //   titleTemplate: `%s | ${this.$t('branding.appName')}`,
    //   htmlAttrs: {
    //     dir: this.direction
    //   },
    //   meta: [
    //     { charset: 'utf-8' },
    //     { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
    //     { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
    //     { hid: 'description', name: 'description', content: this.$t('branding.AppTagline') },
    //     ...favicon.metas
    //   ],
    //   link: [
    //     ...favicon.links
    //   ]
    // }
  },
  computed: {
    ...mapState(['$offline', '$account']),
    direction () {
      return this.$t('direction')
    },
    isPublic () {
      return this.$route.meta && this.$route.meta.public
    }
  },
  watch: {
    $account (val) {
      if (!val) {
        let path = '/login'
        if (this.$route.path !== this.$config.homeUrl) {
          path = `/login?go=${this.$route.path}`
        }
        this.$router.replace(path)
      }
    }
  },
  methods: {
    backFromOffline () {
      this.$store.commit(types.SET_OFFLINE, false)
    }
  }
}
</script>
